import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import UserTab from "./UserTab";

function Users () {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <UserTab />
      <Footer />
    </DashboardLayout>
  );
}

export default Users;
